var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66797 6.51718C1.66797 5.21907 2.72029 4.16675 4.0184 4.16675H10.856C12.1541 4.16675 13.2064 5.21907 13.2064 6.51718V7.18938L16.17 5.70759C17.1645 5.21034 18.3346 5.93351 18.3346 7.04541V12.8265C18.3346 13.9384 17.1645 14.6616 16.17 14.1644L13.2064 12.6826V13.3548C13.2064 14.6529 12.1541 15.7052 10.856 15.7052H4.0184C2.72029 15.7052 1.66797 14.6529 1.66797 13.3548V6.51718ZM11.9244 11.6315C11.9242 11.6404 11.9242 11.6494 11.9244 11.6583V13.3548C11.9244 13.9448 11.4461 14.4232 10.856 14.4232H4.0184C3.42835 14.4232 2.95002 13.9448 2.95002 13.3548V6.51718C2.95002 5.92713 3.42835 5.4488 4.0184 5.4488H10.856C11.4461 5.4488 11.9244 5.92713 11.9244 6.51718V8.21369C11.9242 8.2226 11.9242 8.23152 11.9244 8.24045V11.6315ZM13.2064 11.2492L16.7434 13.0177C16.8854 13.0887 17.0526 12.9854 17.0526 12.8265V7.04541C17.0526 6.88657 16.8854 6.78326 16.7434 6.85429L13.2064 8.62275V11.2492Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.c464a01ef85e48d6d009537ede58c9b9.svg";
export { ForwardRef as ReactComponent };